module.exports = {
    title: "Cancellation Policy",
    crud: {
        create: "Create Cancellation Policy",
        edit: "Edit Cancellation Policy",
        tableTitle:"History",
    },
    table: {
        userType: "User Type",
        hoursBefore: "Hours Before",
        karmaPoint: "Karma Credits",
        pointType: "Credit Type",
        returnPercentage: "Return Percentage",
        actions: "Actions",
        columns:{
            userType:"userType",
            hoursBefore:"hoursBefore",
            karmaPoint:"karmaPoint",
            pointType:"pointType",
            returnPercentage:"returnPercentage",
            actions:"actions",
        }
    },
    form: {
        hoursBefore: "Hours Before",
        karmaPoint: "Karma Credits",
        returnPercentage: "Return Percentage"
    },
    validation: {
        required: {
            currentPercentage: 'Current percentage is required',
            currentApplyDate: 'Current apply date is required',
        }
    },
}
